<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="my-3 mx-2">
      <div class="row">
        <div class="d-flex align-items-center">
          <div class="mx-2 h3">Albums</div>
          <router-link to="/album/create">
            <button class="btn btn-sm border border-primary text-primary" style="">
              Add New Album
            </button>
          </router-link>
        </div>
        <div class="col-md-12 mt-3">
          <b-row class="mt-2">
            <b-col class="col-3 p-1 me-auto" lg="3" md="4" sm="2">
              <b-form-group class="ms-2">
                <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"
                               class="col-md-4" size="sm"></b-form-select>
              </b-form-group>
            </b-col>
            <!-- search  -->
            <b-col class="col-6 p-1" lg="5" md="6" sm="8">
              <div class="d-flex flex-row">
                <b-form-input v-model="filter" :formatter="searchFormatter" class="me-2"
                              placeholder="Type to filter data" type="search"></b-form-input>
                <button class="rounded btn-info me-4" @click="onSearch">Search</button>
              </div>
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-md-12">
              <b-table :busy="loading" :current-page="currentPage" :fields="fields" :items="allAlbums"
                       :per-page="perPage" bordered hover
                       responsive striped>

                <template #cell(active_yn)="row">
                  <div class="d-flex gap-1 justify-content-center">
                    <h5 v-if="row.item.active_yn == 'Y'">
                      <span class="badge bg-success">Active</span>
                    </h5>
                    <h5 v-else>
                      <span class="badge bg-danger">Inactive</span>
                    </h5>
                  </div>
                </template>
                <template #cell(featured_yn)="row">
                  <div class="d-flex gap-1 justify-content-center">
                    <h5 v-if="row.item.featured_yn == 'Y'">
                      <span class="badge bg-success">Yes</span>
                    </h5>
                    <h5 v-else>
                      <span class="badge bg-secondary">No</span>
                    </h5>
                  </div>
                </template>
                <template #cell(actions)="row">
                  <div class="d-flex gap-1 justify-content-center">
                    <router-link :to="{ name: 'editAlbum', params: { id: row.item.id } }">
                      <button class="btn text-primary" style="font-size: 16px;" title="Edit">
                        <span class="fa fa-edit"></span>
                      </button>
                    </router-link>
                  </div>
                </template>
                <template #table-busy>
                  <div class="text-center text-danger my-2 px-2">
                    <b-spinner class="align-middle mx-2"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
              <b-row>
                <b-col class="mt-2" md="12" sm="12">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                                align="center" class="my-0" next-text="Next" prev-text="Prev"
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MediaService from "@/services/media.service";

export default {
  name: "ShowAlbums",
  data() {
    return {
      allAlbums: [],
      backupAllAlbums: null,
      filter: '',
      loading: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 100],
      fields: [
        {
          key: 'album_name', sortable: true, thStyle: {width: "22%"},
          tdClass: "px-3", thClass: "px-3",
        },
        {
          key: 'album_description', sortable: true,
          thStyle: {width: "20%"}, tdClass: "px-3", thClass: "px-3",
        },
        {
          label: 'Status', key: 'active_yn', sortable: true,
          tdClass: "px-3", thClass: "px-3 text-center",
        },
        {
          label: 'Featured', key: 'featured_yn', sortable: false,
          class: 'text-center',
          formatter: (value) => {
            return value == 'Y' ? 'Yes' : 'No'
          },
          filterByFormatted: true
        },
        {
          label: 'Album Slug', key: 'slug', class: 'text-center', thStyle: {width: "20%"},
        },
        {label: 'Actions', key: 'actions', class: 'text-center'},
      ],
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Media',
          href: '#'
        }, {
          text: 'Albums',
          href: '#'
        }
      ],

    }
  },
  mounted() {
    this.fetchAlbums();
  },
  methods: {
    onSearch() {
      if (this.filter != null && this.filter != "") {
        this.allAlbums = [];
        this.backupAllAlbums.forEach(album => {
          if (album.album_name.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allAlbums.push(album);
          } else if (album.album_description.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allAlbums.push(album);
          } else if (album.slug.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allAlbums.push(album);
          }
        });
      } else {
        this.allAlbums = this.backupAllAlbums;
      }
      this.totalRows = this.allAlbums.length;
      this.currentPage = 1;
    },
    searchFormatter(data) {
      this.filter = data;
      if (this.filter != null && this.filter != "") {
        this.allAlbums = [];
        this.backupAllAlbums.forEach(album => {
          if (album.album_name.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allAlbums.push(album);
          } else if (album.album_description.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allAlbums.push(album);
          } else if (album.slug.toLowerCase().includes(this.filter.toLowerCase())) {
            this.allAlbums.push(album);
          }
        });
      } else {
        this.allAlbums = this.backupAllAlbums;
      }
      this.totalRows = this.allAlbums.length;
      this.currentPage = 1;
      return data;
    },
    async fetchAlbums() {
      try {
        const response = await MediaService.getAllAlbums();
        this.allAlbums = response.data;
        this.backupAllAlbums = response.data;
        this.totalRows = this.allAlbums.length;
      } catch (error) {
        console.log(error);
      }

    },
  }
}
</script>

<style scoped>
th,
td {
  padding: 10px !important;
}
</style>